import { Box, Flex, Heading, Grid, Text, Container } from '@radix-ui/themes';
import { Button } from '@trashlab/sitesapp/src/organizations/piedmont/template/components/shared/button';
import { Image } from '@trashlab/sitesapp/src/organizations/piedmont/components/shared/image';
import { useVariantValue } from '@trashlab/sitesapp/src/organizations/piedmont/lib/utils/get-variant-value';
import { useThemeTextColor } from '@trashlab/sitesapp/src/organizations/piedmont/lib/utils/use-theme-text-color';
import { useState } from 'react';
import { DumpsterModal } from '@trashlab/sitesapp/src/organizations/piedmont/template/components/shared/modal/dumpster-modal';

export const HeavyDebrisInfo = ({
  withBackground,
}: {
  withBackground?: boolean;
}) => {
  const { textColorClass, isLightBackground } = useThemeTextColor();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const heavyDebrisImage = useVariantValue(
    'HEAVY_DEBRIS_IMAGE',
    '/default/heavy-debris.svg',
  );

  const heavyDebrisTitle = useVariantValue(
    'HEAVY_DEBRIS_TITLE',
    'Disposing of Heavy Debris?',
  );

  const heavyDebrisDescription = useVariantValue(
    'HEAVY_DEBRIS_DESCRIPTION',
    'If you are disposing of concrete, dirt, sod, brick, rock, sand or any other heavy debris - you will need to rent a concrete dumpster',
  );

  const ctaButtonText = useVariantValue(
    'CTA_BUTTON_TEXT',
    'Explore our services',
  );

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  return (
    <Container
      size="4"
      p="8"
      className={
        withBackground
          ? `relative min-h-[200px] overflow-hidden before:content-[''] before:absolute before:inset-0 before:bg-[url('/default/rental-steps-bg.svg')] before:bg-cover before:bg-center before:bg-no-repeat before:opacity-100 before:-z-10 after:content-[''] after:absolute after:inset-0 after:opacity-90 after:-z-10`
          : ''
      }
    >
      <Grid
        columns={{ initial: '1', sm: '2' }}
        width="auto"
        justify="center"
        align="center"
        className={`rounded-xl relative overflow-hidden before:content-[''] 
          before:absolute before:inset-0 after:content-[''] 
          after:absolute after:inset-0 after:bg-[var(--background-color)] 
          after:opacity-90 after:-z-10`}
      >
        <Box className="order-2 xs:order-1 relative z-10">
          <Box
            className="flex justify-center items-center"
            data-variable="HEAVY_DEBRIS_IMAGE"
          >
            <Image
              src={heavyDebrisImage}
              alt="Heavy debris disposal"
              className="rounded-lg"
            />
          </Box>
        </Box>

        <Flex
          direction="column"
          className="p-4 pl-4 sm:pl-8 md:pl-[68px]"
          gap="4"
        >
          <Heading
            as="h2"
            size="8"
            className={textColorClass}
            data-variable="HEAVY_DEBRIS_TITLE"
          >
            {heavyDebrisTitle}
          </Heading>

          <Text
            size="4"
            className={textColorClass}
            data-variable="HEAVY_DEBRIS_DESCRIPTION"
          >
            {heavyDebrisDescription}
          </Text>

          <Box className="flex col-span-1 justify-start">
            <Button
              withArrow
              scrollToDumpsterTypes
              data-variable="CTA_BUTTON_TEXT"
              isDark={!isLightBackground}
              onClick={handleOpenModal}
            >
              {ctaButtonText}
            </Button>
          </Box>
        </Flex>
      </Grid>
      <DumpsterModal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        defaultType="all"
      />
    </Container>
  );
};

export default HeavyDebrisInfo;
